import { Location } from '@angular/common';
import { Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-header',
  standalone: false,
  templateUrl: './header.component.html',
  styleUrl: './header.component.css',
})
export class HeaderComponent implements OnInit, OnDestroy {
  @ViewChild('menubar') offcanvasRef!: ElementRef;
  @Input() headerType: string = '';
  @Input() isBackButtonVisible = false;
  @Input() isHamburgerMenuVisible = true;
  @Input() headerTitle: string = '';

  @Input() processedItemIndex?: number = 0;
  @Input() totalProcessedItem?: number = 0;
  @Input() workOverviewCount: number = 0;
  @Input() myWorkCount: number = 0;
  @Input() transparentBg = false;

  activeTab: string = 'item';
  currentRoute: string = '';
  enquiryType: string = '';
  isEnableOnlyWms: boolean = false;

  private routeSub!: Subscription;

  constructor(
    private readonly router: Router,
    private readonly location: Location,
  ) {}

  ngOnInit() {
    this.isEnableOnlyWms = environment.enableOnlyWms;
    this.setActiveTabBasedOnRoute(this.router.url);

    // Handle route changes
    this.routeSub = this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.setActiveTabBasedOnRoute(event.urlAfterRedirects);
      });
  }

  ngOnDestroy() {
    if (this.routeSub) {
      this.routeSub.unsubscribe();
    }
  }

  goBack() {
    this.location.back();
  }

  goHome() {
    this.router.navigate(['/work-items']);
  }

  private setActiveTabBasedOnRoute(url: string) {
    this.currentRoute = url;

    if (url.includes('item-inquiry')) {
      this.activeTab = 'item';
    } else if (url.includes('license-plate-inquiry')) {
      this.activeTab = 'licensePlate';
    } else if (url.includes('location-inquiry')) {
      this.activeTab = 'location';
    } else if (url.includes('barcode-inquiry')) {
      this.activeTab = 'barcode';
    } else if (url.includes('work-items')) {
      this.activeTab = 'work';
    } else if (url.includes('work-overview')) {
      this.activeTab = 'overview';
    }
  }

  onTabClick(tab: string, type: string): void {
    this.activeTab = tab; // Apply instantly
    this.enquiryType = tab;
    let route = '';

    switch (tab) {
      case 'work':
        route = 'work-items';
        break;
      case 'overview':
        route = 'work-overview';
        break;
    }

    if (route) {
      setTimeout(() => {
        this.router.navigate([route]);
      }, 50);
    }
  }

  showProcessedIndex(): boolean {
    return ['process', 'summary', 'complete'].includes(this.headerType);
  }
}
